import Vue from 'vue'
import vuetifyObj from './vuetify'
import VuetifyToast from 'vuetify-toast-snackbar'

Vue.use(VuetifyToast, {
  x: 'right',
  y: 'top',
  shorts: {
    success: {
      color: 'green'
    },
    error: {
      color: 'red'
    }
  },
  $vuetify: vuetifyObj.framework
})
